var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveToDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_3540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6917 10.4252L13.425 4.11684L1.23332 1.17517L4.17499 13.3668L10.4833 14.6335L14.6917 10.4252Z",
    fill: "#D4C4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.025 18.9158C12.1083 19.3825 10.9083 18.8992 10.3666 18.0325C9.82498 17.1658 9.85831 16.0242 10.2416 15.0658C10.625 14.1075 11.3 13.3158 12.0166 12.5742C12.775 11.7825 13.6083 11.0242 14.6 10.5658C15.5916 10.1075 16.7916 9.97416 17.7916 10.4408C18.7916 10.9075 19.475 12.0658 19.2166 13.1325",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 8.62504C9.59999 8.10837 9.28333 7.58337 8.80833 7.21671C8.33333 6.85004 7.19166 6.36671 6.66666 6.66671C6.14166 6.96671 6.19999 7.95837 6.66666 8.33337C7.09166 8.67504 8.01666 8.60837 8.26666 8.13337C8.51666 7.65837 8.40833 7.04171 8.10833 6.58337C7.80833 6.12504 7.375 5.79171 6.94166 5.45837C4.90833 3.91671 2.86666 2.37504 0.833328 0.833374",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_3540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveToDraft);
export default __webpack_public_path__ + "static/media/saveToDraft.aa5ada07612c071c44bdcadfc49636d5.svg";
export { ForwardRef as ReactComponent };